import { Directive, Input, output, input } from '@angular/core';

export const TextFormControlDirectiveInputs = ['appendText', 'appendIcon', 'maxLength', 'disabled'];

export const TextFormControlDirectiveOutputs = ['valueChange'];

@Directive({
  selector: '[uiTextFormControl]',
  standalone: true,
})
export class TextFormControlDirective {
  @Input()
  appendText: string | null = null;

  @Input()
  appendIcon: string | null = null;

  @Input()
  maxLength: number | null = null;

  readonly disabled = input(false);

  readonly valueChange = output<string>();
}
